import { AnaColumn } from "../forms-template.service";
import { aspect } from "./aspect";

export const strutturaExcelGriglia: AnaColumn[] = [
  {

    itemType: "group", colCount: "1", data: [
      //{ dataField: "id", colVisible: false, type: 'campo', dataType: "", caption: "ID", hideOnEdit: false, },
      { dataField: "descrizione", type: 'campo', colVisible: true, caption: 'Nome Struttura', dataType: "", hideOnEdit: true, colWidth: '650' },


      //{ dataField: "isPublic", type: 'campo', colVisible: true,caption:'Visibilità' ,dataType: "", hideOnEdit: true, },
      {
        type: 'campo', colVisible: true, editorType: "dxSelectBox", dataField: "tipoStruttura", dataType: "", caption: "Tipo",
        showClearButton: true,
        lista: {
          showClearButton: true,
          static: true,
          caption: 'Visibilità',
          dataSource: 'visibilita',
          valueExpr: 'id',
          displayExpr: 'descrizione',
        }
      },
      {
        type: 'button', dataField: "", colVisible: true, dataType: "", hideOnEdit: true,horizontalAlignment:'center',

        button: {
          name: 'scaricaExcel',
          hint: 'Scarica Excel',
          icon: 'export icon-download-1',
          text: 'Scarica Excel',
          type: 'text',
          event: 'scaricaExcel'
        }
      },

    ]
  },
]

export const strutturaExcel: AnaColumn[] = [

  {
    itemType: "group", caption: "Dati Struttura", groupDataField: 'struttura', colCount: '2', colSpan: '2', class: 'w-100', data:
      [
        {
          type: 'campo', dataField: 'descrizione', colSpan: '1', colVisible: true, width: 20 + 'vw', hideOnEdit: false, caption: 'Nome Struttura', validation: [
            {
              type: 'required',
              message: 'Campo obbligatorio'
            }
          ]
          //,colSpan:'1'
        },

         {
          type: 'campoRadio', dataField: 'tipoStruttura', colVisible: true, hideOnEdit: false, caption: 'Tipo',
          class: 'allineaAlCentro radioGroupWithGaps',
          colSpan: '1',
          defaultValue: 2,
          items: [
            {
              icon: 'glyphicon icon-locked',
              value: 1,
              descrizione: 'Privato',
              alignment: 'center',

            },
            {
              icon: 'glyphicon icon-unlocked',
              value: 2,
              descrizione: 'Pubblico',
              alignment: 'center',


            },
            {
              icon: 'glyphicon icon-pencil-01',
              value: 3,
              descrizione: 'Modificabile',
              alignment: 'center',
            }
          ],

        }, 

        

        {
          type: 'campoSpecial', editorType: 'dxTagBox',
          dataField: "listaOrdinamento", caption: 'Ordine Stampa',    //"Stampa in Ordine di",
          colSpan: '2',
          class: '',
          width: 40 + 'vw',
          colVisible: true,
          tagBoxList: {
            dataSource: undefined,
            displayExpr: 'descrizione',
            valueExpr: 'idFieldDTB',
            maxDisplayedTags: 4,
            multiline: false,

            showSelectionControls: true,

          }
        }
      ],
  },
  {
    itemType: "group", groupDataField: 'trasferisci', caption: '', colCount: "1", class: 'esportaCentrato', data: [
      {
        type: 'simpleButton',
        dataField: "trasferisciColonne",

        colVisible: false,
        class: 'trasferisciColonne blueButton',
        button: {
          text: '',
          icon: 'chevrondoubleright',
          name: "trasferisciColonne",
          event: "trasferisciColonne",
          type: "normal",
          hint: "Trasferisci colonne per la stampa",
          class: 'blueButton'
          //related: ['latidudine', 'longitudine'],
        }
      },

    ]
  },

];

